import { GridController, gridTpl } from '../../../../../../common/grid/grid.controller';
import { IDS } from '../../pnp-doc.constants';
import {getDocumentEventActions} from '../../pnp-doc.actions';

class pnpDocumentEventActionsGridController extends GridController {
    /* @ngInject */
    constructor($ngRedux, $state, NavigationService) {
        super($ngRedux, $state, NavigationService);
        this.$ngRedux = $ngRedux;
    }

    $onInit() {
        this.module = 'policies';
        this.identifier = IDS.pnpDocumentEventActionsGrid;
        this.filterComponent = false;

        this.columns = [
            { title: '#', mapper: null },
            { title: 'Document Number', mapper: 'documentNumber' },
            { title: 'Document Name', mapper: 'documentName' },
            { title: 'Action', mapper: 'actionName' },
            { title: 'Issuer Name', mapper: 'issuerName' },
            { title: 'Date', mapper: 'actionDate' },
            { title: 'Comment', mapper: 'comment' },
        ];

        this.unsubscribe = this.$ngRedux.connect(
            this.mapState().bind(this),
            { getDocumentEventActions }
        )(this);

        this.dataAction = this.getDocumentEventActions;
        this.exportService = this.getDocumentEventActions;
        this.filter.identifier = this.identifier;

        this.init();
    }

    $onDestroy() {
        this.destroy();
        this.$ngRedux.dispatch({
            type: 'GRID_RESET',
            id: IDS.pnpDocumentEventActionsGrid,
        });
    }
}

export const pnpDocumentEventActionsGrid = {
    bindings: {
        title: '@'
    },
    controller: pnpDocumentEventActionsGridController,
    ...gridTpl,
};
